/**
 * @ngdoc directive
 * @name orderline
 *
 * @description
 * Line containing one order detail
 */
module.directive('orderline', function () {
    'use strict';
    return {
        restrict: 'E',
        scope: {
            order: '=content',
            guide: '=',
            upload: '=?'
        },
        controller: ['$scope', '$rootScope', function ($scope, $rootScope) {
                $scope.configSite = $rootScope.config.site;
        }],
        templateUrl: 'src/components/orderline/orderline.html'
    };
});